export enum WorkExperienceTypeEnum {
  ExperienceNeeded = 1,
  WithoutExperience = 2,
  WithExperience = 3,
}
